(($, window) => {
  window.addEventListener('load', () => {
    $('.sn-tabs').each((i, el) => {
      var $tabs = $(el)
      var SimpleBar = $tabs.get(0).SimpleBar
      var wrapper = SimpleBar.getScrollElement()

      $tabs.on('show.bs.tab', function(event) {
        var
        target = event.target,
        rect = target.getBoundingClientRect(),
        win = window.innerWidth / 2;

        wrapper.scroll({
          behavior: 'smooth',
          left: rect.width / 2 + SimpleBar.scrollbarWidth + target.offsetLeft - win
        })

        location.hash = target.getAttribute('href')
      })
    })

    if (!!location.hash) {
      $(`[data-toggle=tab][href=${location.hash}]`).tab('show')
    }
  
    window.addEventListener('hashchange', () => {
      if (!!location.hash) {
        $(`[data-toggle=tab][href=${location.hash}]`).tab('show')
      }
    })

    var
    href = window.location.href,
    query = href.substr( href.indexOf('?') + 1 ),
    params = query.split('&'),
    param = {}

    params.forEach(el => {
      var p = el.split('=')
      param[p[0]] = p[1]
    })

    if (param.tab) {
      var
      tab = `#${param.tab}`,
      offset = 100

      if (!$(tab).length) return

      $(`a[href=${tab}]`).tab('show')
      offset += $('.main-header').height()

      window.scroll({
        behavior: 'smooth',
        top: $('.sn-tabs').offset().top - offset
      })
    }
  })
})(jQuery, window);